import { Link } from 'react-router-dom';

export default function Header() {
  return (
    <header className="bg-white shadow-sm sticky top-0 z-50">
      <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <Link to="/" className="flex items-center cursor-pointer">
            <img 
              src="https://static.readdy.ai/image/e88ada64db3193888b9a84ae586990c8/7b77d793ca7ca810cd6a3e1f07a1b509.png" 
              alt="Total Care Detailing" 
              className="h-12 w-auto"
            />
          </Link>
          
          <div className="hidden md:flex space-x-8">
            <Link to="/" className="text-white hover:text-red-400 transition-colors cursor-pointer">
              Home
            </Link>
            <Link to="/services" className="text-white hover:text-red-400 transition-colors cursor-pointer">
              Services
            </Link>
            <Link to="/about" className="text-white hover:text-red-400 transition-colors cursor-pointer">
              About
            </Link>
            <Link to="/contact" className="text-white hover:text-red-400 transition-colors cursor-pointer">
              Contact
            </Link>
          </div>
        </div>
      </nav>
    </header>
  );
}